import { useEffect } from 'react';

/**
 * Reports react-hook-form's `formState.isDirty` up to a hosting Dialog so it can guard an
 * unsaved-changes dismiss (form-standard.context.md §6). The Dialog chrome for the forms this
 * scaffold currently backs (Register Server / Register Tool / Create Policy / Invite User) is
 * owned by their page components (`src/pages/**`) — those pages already implement the
 * discard-confirm via an `onDirtyChange` callback + `window.confirm`. This hook preserves that
 * exact contract while sourcing dirtiness from RHF's `formState.isDirty` instead of a hand-rolled
 * per-field boolean expression.
 */
export function useReportFormDirty(isDirty: boolean, onDirtyChange?: (dirty: boolean) => void): void {
  useEffect(() => {
    onDirtyChange?.(isDirty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDirty]);
}
